import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  HostListener,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  EMPTY,
  Observable,
  debounceTime,
  filter,
  finalize,
  map,
  startWith,
  switchMap,
  take,
  takeWhile,
} from 'rxjs';
import { TrackNivedanDialogComponent } from 'src/app/admin/track-nivedan-dialog/track-nivedan-dialog.component';
import { Router } from '@angular/router';
import {
  CallService,
  DataService,
  DevoteeService,
  PiopiyService,
  UserService,
} from 'src/app/core/services';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { state } from '@angular/animations';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import moment, { Moment } from 'moment';
@Component({
  selector: 'app-fly-out-new-nibedon-form',
  templateUrl: './fly-out-new-nibedon-form.component.html',
  styleUrls: ['./fly-out-new-nibedon-form.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
  ],
})

export class FlyOutNewNibedonFormComponent implements OnInit, OnChanges {
  @ViewChild('step1Input') step1Input!: ElementRef<HTMLInputElement>;
  @ViewChild('step2Input') step2Input!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('step3Input') step3Input!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('step4Input') step4Input!: ElementRef<HTMLTextAreaElement>;

  @Input() isOpen: boolean = false;
  @Input() performAction: boolean = false;
  @Output() close = new EventEmitter<void>();
  public step: number = 1;
  private _alive: boolean = true;
  ritwikList: any[] = [];
  nivedonCategory: any[] = [];
  devoteeDetailsForm!: FormGroup;
  addressDetailsForm!: FormGroup;
  otherDetailsForm!: FormGroup;
  nibedonDetailsForm!: FormGroup;
  allowedKeys = ['Enter', 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
  postOfficeArray: any[] = [];
  districtArray: any[] = [];
  stateArray: any[] = [];
  public apiData: any;
  showPrimaryStepError = false;
  showAddressStepError = false;
  showNibedonStepError = false;
  otherDetailsStepError = false;
  pasteErrors: any = {
    firstName: false,
    middleName: false,
    lastName: false,
  };
  isLoading: boolean = false;
  draftResponse: any[] = [];
  isDraft: boolean = false;
  isSubmitting: boolean = false;
  isFinalSubmit: boolean = false;

  constructor(
    private fb: FormBuilder,
    private _devoteeService: DevoteeService,
    private _dataService: DataService,
    private _dialog: MatDialog,
    private userService: UserService,
    private callService: CallService,
    private toaster: ToastrService,
    private piopiyService: PiopiyService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true) {
      setTimeout(() => {
        this.step1Input?.nativeElement?.focus();
      }, 0);
    }



  }
  private focusMap: Record<number, () => void> = {
    1: () => this.step1Input?.nativeElement?.focus(),

    2: () => this.step2Input?.nativeElement?.focus(),

    3: () => this.step3Input?.nativeElement?.focus(),

    4: () => this.step4Input?.nativeElement?.focus(),
  };

  focusCurrentStep() {
    setTimeout(() => {
      this.focusMap[this.step]?.();
    }, 150);
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'ArrowLeft') {
      event.preventDefault();
      if (this.step > 1) {
        this.step--;
      }
    }
    if (event.key === 'Enter' && this.step < 4) {
      event.preventDefault();
      this.nextStep();
    }
  }

  ngOnInit(): void {

    this.getDraftData()

    this._dataService.categoryList$.subscribe((res) => {
      this.nivedonCategory = res;
    });

    this.devoteeDetailsForm = this.fb.group({
      firstName: ['', [Validators.required]],
      middleName: [''],
      lastName: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]],
      alternatePhoneNumber: [''],
      familyCode: [''],
      age: ['', [Validators.required]],
      gender: ['', [Validators.required]],
    });

    this.addressDetailsForm = this.fb.group({
      address: ['', [Validators.required]],
      pincode: ['', [Validators.required]],
      district: ['', Validators.required],
      po: ['', [Validators.required]],
      state: ['', [Validators.required]],
    });

    this.otherDetailsForm = this.fb.group({
      nivedanCategory: ['', Validators.required],
      initiated: [''],
      swastayini: ['',],
      ritwikName: [''],
      maritalStatus: ['', [Validators.required]],
    });

    this.nibedonDetailsForm = this.fb.group({
      nibedon: ['', [Validators.required]],
      remarks: [''],
      isUrgent: [false]
    });

    this.callService.callSubject$.subscribe({
      next: (res) => {

        this.isOpen = res
      },
      error: (err) => {
        this.toaster.error(err)
      }
    })


    // For Fetching Pincode

    this.addressDetailsForm
      .get('pincode')
      ?.valueChanges.subscribe((val: any) => {
        this.stateArray = [];
        this.districtArray = [];

        if (val?.length === 6) {
          this.userService.getPINInfo(val).subscribe({
            next: (res) => {
              this.apiData = res?.data || {};
              this.stateArray = Object.keys(this.apiData);

              if (this.stateArray.length === 1) {
                const state = this.stateArray[0];
                this.addressDetailsForm.get('state')?.setValue(state);

                this.districtArray = Object.keys(this.apiData[state] || {});
                this.postOfficeArray = this.apiData[state][this.districtArray[0]].po

                if (this.districtArray.length === 1) {
                  this.addressDetailsForm
                    .get('district')
                    ?.setValue(this.districtArray[0]);
                }
                const po = this.addressDetailsForm.get('po');
                if (this.postOfficeArray.length === 1) {
                  this.addressDetailsForm.get('po')?.setValue(this.postOfficeArray[0])
                  // po?.disable({ emitEvent: false });
                } else {
                  po?.enable({ emitEvent: false });
                }
                const dist = this.addressDetailsForm.get('district');
                if (this.districtArray.length === 1) {
                  // dist?.disable({ emitEvent: false });
                } else {
                  dist?.enable({ emitEvent: false });
                }
              } else {
                this.addressDetailsForm.get('state')?.enable()
              }
            },
            error: (err) => {
              this.toaster.error(err.error.message);
              if (err) {
                this.addressDetailsForm.get('state')?.enable();
                this.addressDetailsForm.get('district')?.enable();
                this.addressDetailsForm.get('po')?.enable();
              }
            }
          })
        } else {
          this.addressDetailsForm.get('state')?.reset();
          this.addressDetailsForm.get('district')?.reset();
          this.addressDetailsForm.get('po')?.reset();
          this.stateArray = [];
          this.districtArray = [];
          this.postOfficeArray = []
        }
      });


    // For Fetching Ritwik Name
    this.otherDetailsForm
      .get('ritwikName')
      ?.valueChanges.pipe(debounceTime(300))
      .subscribe((val: string) => {
        if (val?.length >= 3) {
          this.userService.getRitwiks(val).subscribe({
            next: (res) => {
              this.ritwikList = res.data;
            },
            error: (err) => {
              this.toaster.error(err.error.message);
            },
          });
        }
      });
  }

  onSelectingDistrict(event: any) {
    const currentState = this.addressDetailsForm.get('state')?.value
    this.postOfficeArray = this.apiData[currentState][event.value].po

  }

  onSelectingState(event: any) {
    this.districtArray = Object.keys(this.apiData[event.value])
    if (this.districtArray.length === 1) {
      this.addressDetailsForm.get('district')?.setValue(this.districtArray[0])
    } else {
      this.addressDetailsForm.get('district')?.enable()
    }
    // const currentDistrict =  this.addressDetailsForm.get('district')?.value
    this.postOfficeArray = this.apiData[event.value][this.districtArray[0]].po
    if (this.postOfficeArray.length === 1) {
      this.addressDetailsForm.get('po')?.setValue(this.postOfficeArray[0])
      this.addressDetailsForm.get('po')?.disable()
    } else {
      this.addressDetailsForm.get('po')?.enable()
    }

  }

  onClose() {
    this.callService.openSlider(false);
    this.close.emit();
    this.isOpen = false
    this.step = 1;
    this.devoteeDetailsForm.reset();
    this.addressDetailsForm.reset(),
      this.otherDetailsForm.reset(),
      this.nibedonDetailsForm.reset()
  }

  nextStep() {
    this.step += 1;
    this.focusCurrentStep();

    if (this.step == 2) {
      this.devoteeDetailsForm.touched;
      console.log(this.devoteeDetailsForm.touched);

      this.devoteeDetailsForm.invalid ? this.showPrimaryStepError = true : this.showPrimaryStepError = false;
    }

    if (this.step == 3) {
      this.addressDetailsForm.touched;
      this.addressDetailsForm.invalid ? this.showAddressStepError = true : this.showAddressStepError = false;
    }
    if (this.step == 4) {
      this.otherDetailsForm.touched;
      this.otherDetailsForm.invalid ? this.showNibedonStepError = true : this.showNibedonStepError = false;
    }
  }

  prevStep() {
    this.step -= 1;
    this.focusCurrentStep();
  }

  navigateToSpecificForm(count: number) {
    this.step = count;
  }

  allowedLetters(event: KeyboardEvent) {
    if (this.allowedKeys.includes(event.key)) {
      return;
    }

    const regex = /^[a-zA-Z]$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  validatePaste(event: ClipboardEvent, field: string): void {

    const pastedText = event.clipboardData?.getData('text') || '';

    const regex = /^[a-zA-Z\s]+$/;

    if (!regex.test(pastedText)) {

      event.preventDefault();

      this.pasteErrors[field] = true;

      setTimeout(() => {
        this.pasteErrors[field] = false;
      }, 5000);

    }

  }

  allowedDigits(event: KeyboardEvent) {

    // Allow: Backspace, Delete, Tab, Escape, Enter, Arrow keys
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown'
    ];

    // Allow Ctrl/Cmd shortcuts
    if (
      event.ctrlKey ||
      event.metaKey ||
      allowedKeys.includes(event.key)
    ) {
      return;
    }

    // Allow only digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  nivedanCode: string = '';
  onSubmit() {
    if (!this.nibedonDetailsForm.invalid && !this.nibedonDetailsForm.invalid && !this.showNibedonStepError && !this.showAddressStepError && !this.showPrimaryStepError) {
      this.isFinalSubmit = true
      this._devoteeService
        .addNewDevotee(
          this.devoteeDetailsForm.value,
          this.addressDetailsForm.value,
          this.otherDetailsForm.value,
          this.nibedonDetailsForm.value
        )
        .pipe(
          takeWhile(() => this._alive),
          finalize(() => { })
        )
        .subscribe({
          next: (res) => {
            if (res) {
              this.isFinalSubmit = false;
              // this.dialogRef.close(res);
              this.callService.openSlider(false);
              this.isOpen = false;
              const dialofRef = this._dialog.open(TrackNivedanDialogComponent, {
                data: {
                  nivedanCode: res.data.nivedanCode,
                  devoteeDetailsForm: this.devoteeDetailsForm.value,
                  addressDetailsForm: this.addressDetailsForm.value,
                  otherDetailsForm: this.otherDetailsForm.value,
                  nibedonDetailsForm: this.nibedonDetailsForm.value,
                },
                width: '400px',
                height: '458px',
                disableClose: true,
              });
              dialofRef.afterClosed().subscribe({
                next: (res) => {
                  if (res.call == 'existing') {
                    this.devoteeDetailsForm.setValue(res.devoteeDetailsForm);
                    this.addressDetailsForm.setValue(res.addressDetailsForm);
                    this.otherDetailsForm.setValue(res.otherDetailsForm);
                    this.nibedonDetailsForm.setValue(res.nibedonDetailsForm);
                    console.log(this.devoteeDetailsForm.value, 'call');
                  } else if (!res) {
                    this.devoteeDetailsForm.reset(),
                      this.addressDetailsForm.reset(),
                      this.otherDetailsForm.reset(),
                      this.nibedonDetailsForm.reset()
                  }
                  this.step = 1
                }
              })
            }
          },
          error: (error) => {
            this.isFinalSubmit = false
            this.toaster.error(
              error?.error?.error?.message
            );
          }
        });
    } else {
      this.toaster.error('Please fill all required fields before submitting.')
    }
  }

  onRitwikDropDown(ritwik: any) {
    this.otherDetailsForm
      .get('ritwikName')
      ?.setValue(ritwik.fullName, { emitEvent: false });
  }

  getDraftData(): void {
    this.callService.draftData$
      .pipe(
        filter((res): res is any[] => res !== null),
      )
      .subscribe(res => {
        this.draftResponse = res;

        if (res.length > 0) {
          this.isDraft = false;
          this.setFormDetails(this.draftResponse[0]);

        } else {
          this.isDraft = true;

          this.callService.dataSubject$
            .pipe(take(1))
            .subscribe(action => {
              this.performAction = action;
              this.step = 1;

              if (!this.performAction) {
                this.devoteeDetailsForm.reset();
                this.addressDetailsForm.reset();
                this.otherDetailsForm.reset();
                this.nibedonDetailsForm.reset();
              }
            });
        }
      });
  }

  setFormDetails(item: any) {
    this.addressDetailsForm?.get('state')?.enable();
    this.addressDetailsForm?.get('district')?.enable();
    this.addressDetailsForm?.get('po')?.enable();

    //devotee Details
    this.devoteeDetailsForm?.patchValue({
      firstName: item.devotee?.firstName ?? '',
      middleName: item.devotee?.middleName ?? '',
      lastName: item.devotee?.lastName ?? '',
      phoneNumber: item.devotee?.phoneNumber ?? '',
      alternatePhoneNumber: item.devotee?.alternateMobileNumber ?? '',
      age: item.devotee?.age ?? '',
      gender: item.devotee?.gender ?? '',
      familyCode: item.devotee?.familyCode ?? '',
    })

    // Devotee Address 
    this.addressDetailsForm?.patchValue({
      state: item.devotee?.state ?? '',
      district: item.devotee?.dist ?? '',
      pincode: item.devotee?.pin ?? '',
      po: item.devotee?.postOffice ?? '',
      address: item.devotee?.address ?? ''
    })

    // other devotee details
    this.otherDetailsForm?.patchValue({
      nivedanCategory: item.categoryCode,
      initiated: item.devotee?.initiated ?? '',
      ritwikName: item.devotee?.ritwikName ?? '',
      swastayini: item.devotee?.swastayani ?? '',
      maritalStatus: item.devotee?.maritalStatus ?? '',
    })

    // nivedan details
    this.nibedonDetailsForm?.patchValue({
      nibedon: item.nivedanDetails ?? '',
      remarks: item.remark ?? '',
      isUrgent: item.isUrgent ?? ''
    })
  }

  addToDraft() {
    if(this.devoteeDetailsForm.get('phoneNumber')?.valid && this.nibedonDetailsForm.get('nibedon')?.valid){
    this.isLoading = true
    this._devoteeService
      .nivedanToDraft(
        this.devoteeDetailsForm.value,
        this.addressDetailsForm.value,
        this.otherDetailsForm.value,
        this.nibedonDetailsForm.value
      )
      .pipe(
        takeWhile(() => this._alive),
        finalize(() => { })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.callService.onCloseSlider()
          this.toaster.success('Successfully moved to nivedan draft')
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error.error.message)
        }
      })
    }else{
      this.toaster.error('Devotee phone number and nivedan details are mandatory fields to save in draft')
    }
  }


  submitDraftNivedan() {
    if (!this.nibedonDetailsForm.invalid && !this.nibedonDetailsForm.invalid && !this.showNibedonStepError && !this.showAddressStepError && !this.showPrimaryStepError) {
      this.isSubmitting = true;
      this._devoteeService.draftNivedanSubmit(
        this.draftResponse[0].nivedanCode,
        this.devoteeDetailsForm.value,
        this.addressDetailsForm.value,
        this.otherDetailsForm.value,
        this.nibedonDetailsForm.value).subscribe({
          next: (res) => {
            // this.onClose()
          this.callService.onCloseSlider()
      this.isSubmitting = false;

            this.isOpen = false;
            const dialofRef = this._dialog.open(TrackNivedanDialogComponent, {
              data: {
                  nivedanCode: this.draftResponse[0].nivedanCode,
                  devoteeDetailsForm: this.devoteeDetailsForm.value,
                  addressDetailsForm: this.addressDetailsForm.value,
                  otherDetailsForm: this.otherDetailsForm.value,
                  nibedonDetailsForm: this.nibedonDetailsForm.value,
                },
              width: '400px',
              height: '458px',
              disableClose: true,
            });
            dialofRef.afterClosed().subscribe({
              next: (res) => {
                console.log(res, 'track');
                
                if (res.call == 'existing') {
                  this.devoteeDetailsForm.setValue(res.devoteeDetailsForm);
                  this.addressDetailsForm.setValue(res.addressDetailsForm);
                  this.otherDetailsForm.setValue(res.otherDetailsForm);
                  this.nibedonDetailsForm.setValue(res.nibedonDetailsForm);
                console.log(this.devoteeDetailsForm.value, 'call');

                } else if (!res) {
                  this.devoteeDetailsForm.reset(),
                    this.addressDetailsForm.reset(),
                    this.otherDetailsForm.reset(),
                    this.nibedonDetailsForm.reset()
                }
                this.step = 1
              }
            })
            this.toaster.success('Successfully draft nivedan is submitted')
          },
          error: (error) => {
      this.isSubmitting = false;

            this.toaster.error(error.error.message)
          }
        })
    } else {
      console.log('submitDraft');
      this.toaster.error('Please fill all required fields before submitting.')
    }
  }
}
